var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React, { useMemo } from 'react';
import styled from '@emotion/styled';
import { space, width, maxWidth, display, alignItems } from 'styled-system';
import { boxSizing } from '../../common/theme/system-utilities';
import { getTrackerProps } from '../../common/tracking/getTrackerProps';
import { Link } from '../../common/components/Link';
import { Text } from '../../common/components/Text';
import LinkSectionListItemImage from './LinkSectionListItemImage';
var Li = styled.li(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n"], ["\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n"])), display, width, space, alignItems, maxWidth, boxSizing);
Li.defaultProps = {
    display: 'flex',
    alignItems: 'flex-start',
    maxWidth: '100%',
    boxSizing: 'border-box',
};
var ItemLink = styled(Link)(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  ", ";\n  ", ";\n  /* Custom link styles for the footer */\n  text-decoration: none !important;\n\n  &:active {\n    font-weight: bold;\n  }\n"], ["\n  ", ";\n  ", ";\n  /* Custom link styles for the footer */\n  text-decoration: none !important;\n\n  &:active {\n    font-weight: bold;\n  }\n"])), display, width);
ItemLink.defaultProps = __assign(__assign({}, Link.defaultProps), { display: 'block', width: 1, fontSize: ['fs_14', null, null, 'fs_16'], lineHeight: ['lh_20', null, null, 'lh_24'] });
var ItemText = styled(Text)(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  ", ";\n"], ["\n  ", ";\n"])), width);
ItemText.defaultProps = __assign(__assign({}, Text.defaultProps), { width: 1, fontSize: ['fs_14', null, null, 'fs_16'], lineHeight: ['lh_20', null, null, 'lh_24'] });
var getItemTrackerProps = function (_a) {
    var hasImage = _a.hasImage, href = _a.href, title = _a.title, target = _a.target, label = _a.name;
    return getTrackerProps(__assign(__assign({ 'data-testid': 'link-section-link', href: href,
        title: title,
        target: target }, (target === '_blank' && {
        rel: 'noreferrer',
    })), { onClick: function (event) {
            // Prevent tracking if the element is not an anchor or image
            event.nativeEvent.trackingPreventDefault = !['A'].includes(event.currentTarget.nodeName);
        } }), __assign(__assign({ event: 'footerTracking' }, (hasImage && { eventCategory: 'image' })), { eventData: __assign({ placement: 'linkSection', labelIdentifier: 'h24_footer_link_section' }, (hasImage && { label: label })) }));
};
var getItemPaddingRight = function (hasImage, isInline) {
    switch (true) {
        case hasImage:
            return 'sp_16';
        case isInline:
            return ['sp_16', 'sp_24', null, 'sp_48'];
        default:
            return ['sp_16', 'sp_24', null, 'sp_32'];
    }
};
var LinkSectionListItem = function (_a) {
    var index = _a.index, item = _a.item, isInline = _a.isInline;
    var Item = !!item.href ? ItemLink : ItemText;
    var hasImage = !!item.image;
    var itemWidth = isInline || hasImage ? 'auto' : [1 / 2, 1 / 4, 1 / 2, 1 / 3];
    var itemPaddingY = hasImage ? 'sp_8' : 'sp_4';
    var itemPaddingRight = useMemo(function () { return getItemPaddingRight(hasImage, isInline); }, [isInline, hasImage]);
    return (React.createElement(Li, { pr: itemPaddingRight, py: itemPaddingY, width: itemWidth, "data-testid": "link-section-list-item-" + index },
        React.createElement(Item, __assign({}, getItemTrackerProps(__assign({ hasImage: hasImage }, item))), hasImage ? (React.createElement(LinkSectionListItemImage, __assign({}, item.image, { alt: item.name }))) : (React.createElement("span", { "data-testid": "link-section-link-label" }, item.name)))));
};
export default LinkSectionListItem;
var templateObject_1, templateObject_2, templateObject_3;
